module.exports = __webpack_public_path__ + "statics/img/5-2.a6acf3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/5-2.png
// module id = xCqh
// module chunks = 1